import { Link } from "react-router-dom";
import { Shield } from "lucide-react";

/**
 * Banner fixo das telas de admin quando o 2FA está vencido (FS-056, C1012922).
 *
 * O backend recusa a AÇÃO com 403 (`recusar_se_mfa_vencido`); sem este aviso o
 * operador clicava e só via um toast efêmero. Mesmo estilo do aviso de 2FA do
 * Dashboard (AdminOverview), com link para onde o 2FA é ativado.
 */
export default function MfaBlockedBanner({ action }) {
  return (
    <div className="p-4 rounded-xl border bg-red-500/15 border-red-500/30" role="alert" data-testid="mfa-blocked-banner">
      <div className="flex items-start gap-3">
        <Shield className="w-5 h-5 text-red-400 mt-0.5 shrink-0" />
        <p className="text-sm">
          <span className="font-semibold text-red-400">2FA obrigatório</span>
          {" — "}
          <Link to="/admin" className="underline underline-offset-2 hover:text-foreground">ative a autenticação de dois fatores no Dashboard</Link>
          {` para ${action}.`}
        </p>
      </div>
    </div>
  );
}
